import { toast } from "react-toastify";
import Opportunity, { IOpportunityQueryParam } from "models/opportunity";
import { PaginatedResult } from "models/queryable";
import { buildQueryString } from "utils/query-string";

export const getOpportunities = async (query?: IOpportunityQueryParam): Promise<PaginatedResult<Opportunity> | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/opportunity${buildQueryString(query)}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as PaginatedResult<Opportunity>;

    } catch (err: any) {
        toast.error(err.message ?? "Error getting opportunities");
        return null;
    }
}

// Starts the Lambda; returns true when it was triggered (the page polls the sync log).
export const syncOpportunitydata = async (): Promise<boolean> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/opportunity/sync`;
        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST'
        });

        if (!res.ok) {
            const errRes = await res.json();
            toast.error(errRes.message);
            return false
        }
        toast.success("Sync started. The page will refresh automatically when it finishes.")
        return true
    } catch (err: any) {

        toast.error("Something went wrong. Could not sync data")
        console.error('Error syncing data:', err);
        return false
    }
} 